/*
 * SonarQube
 * Copyright (C) 2009-2024 SonarSource SA
 * mailto:info AT sonarsource DOT com
 *
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with this program; if not, write to the Free Software Foundation,
 * Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 */
import { Dict } from '../../../types/types';

export const complementary: Dict<string[]> = {
  coverage: ['uncovered_lines', 'uncovered_conditions'],
  line_coverage: ['uncovered_lines'],
  branch_coverage: ['uncovered_conditions'],
  uncovered_lines: ['line_coverage'],
  uncovered_conditions: ['branch_coverage'],

  new_coverage: ['new_uncovered_lines', 'new_uncovered_conditions'],
  new_line_coverage: ['new_uncovered_lines'],
  new_branch_coverage: ['new_uncovered_conditions'],
  new_uncovered_lines: ['new_line_coverage'],
  new_uncovered_conditions: ['new_branch_coverage'],

  duplicated_lines_density: ['duplicated_lines'],
  new_duplicated_lines_density: ['new_duplicated_lines'],
  duplicated_lines: ['duplicated_lines_density'],
  new_duplicated_lines: ['new_duplicated_lines_density'],
};
